import { HTMLAttributes } from 'react';
import { TOPBAR_HEIGHT } from '@sib/ui';
import { GlobalSearch } from './GlobalSearch';
import { UserMenu } from './UserMenu';
import SibLogo from '/sidecar-logo.png';

export interface TopBarProps extends HTMLAttributes<HTMLElement> {}

export const TopBar = ({ ...props }: TopBarProps) => (
  <header
    className="fixed top-0 right-0 left-0 z-50 flex w-screen items-center border-b bg-white pr-6 shadow-md"
    style={{ height: TOPBAR_HEIGHT }}
    {...props}
  >
    <div className="flex h-full w-13 items-center justify-center border-r border-gray-200 p-0.5">
      <img src={SibLogo} alt="Logo" />
    </div>
    <div className="flex flex-[1_1] items-center gap-2">
      <GlobalSearch />
    </div>
    <UserMenu />
  </header>
);
